import type { PostHog } from "posthog-js";

export interface UserAnalyticsInstance {
	identify: (
		userId: string,
		customData: Record<string, string | number | boolean>,
	) => void;
}

// there's probably a better way to handle when to send events
export class UserAnalytics implements UserAnalyticsInstance {
	private static instance: UserAnalytics | null = null;
	private postHog: PostHog;

	static getInstance(postHog: PostHog): UserAnalytics {
		if (!UserAnalytics.instance) {
			UserAnalytics.instance = new UserAnalytics(postHog);
		}
		return UserAnalytics.instance;
	}

	private constructor(postHog: PostHog) {
		this.postHog = postHog;
	}

	identify = (
		userId: string,
		customData: Record<string, string | number | boolean>,
	) => {
		this.postHog.identify(userId, customData);
	};
}
